// extracted by mini-css-extract-plugin
module.exports = {"samlLoginForm":"SamlLogin_samlLoginForm__24ZWS","loginButton":"SamlLogin_loginButton__1yCrF","messageContainer":"SamlLogin_messageContainer__1Jz8K"};